import { useState } from 'react'

const useCollapsibleProducts = (initiallyOpen: boolean, forceOpen: boolean) => {
  const [open, setOpen] = useState(initiallyOpen)

  const toggle = () => setOpen(value => !value)

  return { isOpen: open || forceOpen, toggle }
}

export default useCollapsibleProducts
